import { capitalize } from "lodash-es";

import { ConfirmationModal } from "src/base-components/ConfirmationModal";
import {
  FeatureMappingOutput,
  PreviewQueryRequestEnvironmentEnum,
} from "src/clients/features-control";
import {
  ActiveQueryConfirmationModal,
  UsedFeaturesList,
} from "src/featureCatalogue/Queries/ActiveQueryConfirmationModal";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";

type BaseProps = {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: () => void;
};

type Props =
  | (BaseProps & {
      isActive: true;
      environment: PreviewQueryRequestEnvironmentEnum;
      entities: string[];
      event: string;
      features: FeatureMappingOutput[];
    })
  | (BaseProps & {
      isActive: false;
      features: FeatureMappingOutput[];
    });

export const QueryToggleConfirmationModal = (props: Props) => {
  const { isOpen, closeModal, onConfirm, isActive } = props;

  const featureLifecycleEnabled = isFeatureFlagEnabled(
    FEATURE_FLAGS.featureLifecycle,
  );

  if (!isOpen) {
    return null;
  }

  if (isActive) {
    return (
      <ActiveQueryConfirmationModal
        confirmationButtonText="Deactivate"
        description={`This Query and the Features generated by it are currently active on ${capitalize(props.environment)} data. Deactivating might break the Decision Flows and Jobs that use them.`}
        environment={props.environment}
        isOpen={isOpen}
        query={{
          event: props.event,
          columns: {
            entities: props.entities.map((entity_name) => ({
              entity_name,
              column_name: "",
            })),
            features: props.features,
          },
        }}
        title="Deactivate Query?"
        variant="danger"
        onClose={closeModal}
        onConfirm={onConfirm}
      />
    );
  }

  return (
    <ConfirmationModal
      confirmationButtonText="Activate"
      description={
        <div className="flex flex-col gap-y-4 font-inter-normal-13px">
          <span>
            Once you activate, you might not be able to edit the Query nor its
            associated Features. Are you sure you want to activate this Query?
          </span>
          {featureLifecycleEnabled && (
            <UsedFeaturesList features={props.features} />
          )}
        </div>
      }
      open={isOpen}
      title="Activate Query"
      variant="default"
      onClose={closeModal}
      onConfirm={onConfirm}
    />
  );
};
